import './MarketDropdown.css';const o = "_marketDropdownContainer_1m8zs_1", n = {
  marketDropdownContainer: o
};
export {
  n as default,
  o as marketDropdownContainer
};
